<template>
    <div>
        <Header :title="title" :showBack="true"></Header>

        <!-- 日期选择组件 -->
        <SelectDate v-model:selectDate="selectDate"></SelectDate>

        <!-- 内容 -->
        <div class="nodeManage">
            <van-cell-group>
                <!-- 线路 -->
                <van-cell is-link @click="showLine = true">
                    <template #icon>
                        <div class="cellIconClass">
                            <span class="iconfont iconxianlu1"></span>
                        </div>
                    </template>
                    <template #title>
                        <div class="flex">
                            <div class="cellTitleClass" style="flex: 1;">
                                {{ line ? line.text : "暂无数据" }}
                            </div>
                            <div style="margin: 0 0.2rem;">
                                {{ orgLineNameList.length }}条
                            </div>
                        </div>
                    </template>
                </van-cell>
                <!-- 站点 -->
                <van-cell is-link @click="showNode = true">
                    <template #icon>
                        <div class="cellIconClass">
                            <van-icon name="location-o" />
                        </div>
                    </template>
                    <template #title>
                        <div class="flex">
                            <div class="cellTitleClass" style="flex: 1;">
                                上车点：{{ startNode ? startNode.NodeName : "请选择站点" }}
                            </div>
                        </div>
                    </template>
                </van-cell>
                <van-cell is-link @click="showEndNode = true">
                    <template #icon>
                        <div class="cellIconClass">
                            <van-icon name="location-o" />
                        </div>
                    </template>
                    <template #title>
                        <div class="flex">
                            <div class="cellTitleClass" style="flex: 1;">
                                下车点：{{ arrivalNode ? arrivalNode.NodeName : "未选择站点" }}
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="lineCheck_checkStats_container">
                <div class="stats_panel">
                    <ul class="flex text-center w-full">
                        <li class="flex-1">
                            <p class="stats_item_title">已售数：</p>
                            <p class="stats_item_value">{{ lineTicketInfo.SaleCount }}</p>
                        </li>
                        <li class="flex-1">
                            <p class="stats_item_title">已检数：</p>
                            <p class="stats_item_value" style="color: green;">{{ lineTicketInfo.CheckCount }}</p>
                        </li>
                        <li class="flex-1">
                            <p class="stats_item_title">未检数：</p>
                            <p class="stats_item_value" style="color: red">{{ lineTicketInfo.SaleCount
            - lineTicketInfo.CheckCount }}
                            </p>
                        </li>
                        <li> <van-button icon="replay" size="small" type="default"
                                @click="onGetLineNodeTicket">刷新</van-button></li>
                    </ul>

                </div>
            </div>
            <!-- 站点及车辆列表 -->
            <div class="nodeCarList" v-if="line && startNode">
                <van-tabs swipeable :ellipsis="false" style="z-index: 0;" v-model="tabactive" color="#5470C6"
                    @click="tabsClick">

                    <!-- 检票 -->
                    <van-tab title="线路检票">
                        <div style="margin-top: 0.1rem;display: flex;">
                            <van-button size="normal" icon="passed" style="flex: 1;margin:  0.1rem;margin-left: 0;"
                                @click="onFaseSeatBtnClick">订位</van-button>
                            <van-button size="normal" icon="scan" style="flex: 1;margin:  0.1rem;"
                                @click="onCallCameraScan">检票</van-button>
                            <van-button size="normal" icon="logistics" style="flex: 1;margin:  0.1rem;margin-right: 0;"
                                @click="onSendCar">发车</van-button>
                        </div>
                        <van-search v-model="findNumber" placeholder="请输入条码或手机号码后四位" show-action
                            @search="onCheckByIdNumber(findNumber)">
                            <div slot="action" @click="onCheckByIdNumber(findNumber)">
                                <van-button>查询</van-button>
                            </div>
                        </van-search>
                    </van-tab>

                    <van-tab title="未检列表">
                        <div>

                            <div v-for="(item, index) in  noCheckTicketList" style="margin-top: 0.2rem;">
                                <div style="display: flex;">
                                    <van-tag type="warning">{{ (index + 1) + ((noCheckTicketPage - 1) * 5) }}</van-tag>
                                    <div
                                        style="flex:content; display: flex;align-items: center;justify-content: space-between;background-color: white;line-height:0.7rem;font-size: 14px;font-weight: 600;">
                                        <div style="text-align: center;padding: 0.1rem;margin-left: 0.2rem;">
                                            <div>{{ item.CustName + ' ' + item.CustCertNo }}</div>
                                            <div>{{ item.BarCode }}</div>
                                        </div>
                                        <div style="text-align: center;margin-right: 1rem">
                                            <a @click.stop @click="getTicketTel(item)" class="flex" style="color: blue;"
                                                v-if="item.CustTel && item.CustTel.length == 11">
                                                <span class="iconfont icondianhua"></span>
                                                {{ item.CustTel }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="noCheckTicketList.length == 0" class="line-empty">
                                暂无数据
                            </div>
                            <div style="margin-top: 0.2rem;margin-bottom: 0.2rem;height: 1.5rem;display: flex;">
                                <div style="flex: 8;">
                                    <van-pagination v-model="noCheckTicketPage"
                                        :page-count="Math.ceil(noCheckTicketCount / 5)" mode="simple" />
                                </div>
                                <div style="flex: 2;">
                                    <van-button icon="replay" size="normal" type="default" block style="height:40px"
                                        @click="onRepalyNoCheckTicektList">刷新</van-button>
                                </div>
                            </div>
                        </div>

                    </van-tab>

                    <!-- 发车 -->
                    <van-tab title="发车记录">
                        <div>
                            <div class="order_panel mt-1 " style="display: flex;justify-content: space-between;">
                                <div style="font-weight:700;font-size:.4rem; margin-right:.5rem">合计</div>
                                <div style="font-weight:700;font-size:.4rem; margin-right:.5rem">
                                    <span style="margin-right: 1rem;"> 发车次数:
                                        <span style="color:red">{{ lineDepartureRecordList.length }}</span></span>
                                    <span>发车人数:
                                        <span style="color:red">{{ lineDepartureRecordList.reduce((sum, item) => sum +
            item.PassengerCount, 0) }}</span> </span>
                                </div>
                            </div>

                            <div v-for="(item, index) in  lineDepartureRecordList" style="margin-top: 0.2rem;">
                                <div style="display: flex;"> <van-tag type="warning">{{ index + 1 }}</van-tag>
                                    <van-cell title-style="font-size:16px;color: black;"
                                        :title="item.VehicleNo + '  ' + item.DriverName"
                                        :value="item.PassengerCount + '人'"
                                        :label="$moment(item.CreateTime).format('YYYY-MM-DD HH:mm')" />
                                </div>

                            </div>
                            <div v-if="lineDepartureRecordList.length == 0" class="line-empty">
                                暂无数据
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </div>

        <!-- 线路弹窗选择 -->
        <van-popup v-model="showLine" position="bottom" style="height: 100%;" class="linePopup">
            <van-sticky>
                <van-search v-model="searchLineValue" placeholder="请输入线路代码或名称" show-action @cancel="showLine = false" />
            </van-sticky>
            <van-pull-refresh class="line-pull-refresh" v-model="lineRefresh" @refresh="onGetCompLine"
                style="background-color: #f1f1f1;">
                <!-- 置顶线路 -->
                <div v-if="handlerSearchSetTopList.length != 0">
                    <p class="line-title">置顶线路</p>
                    <van-cell v-for="(item, index) in handlerSearchSetTopList" :key="index" :title="item.text" is-link
                        @click="onLineConfirm(item)" :class="['line-item', { 'label-bold': line.text === item.text }]">
                        <template #title>
                            <div class="line-item-title">
                                <div class="line-item-top" @click="onSetTop(item, $event, 'delete')">
                                    <i class="iconfont iconquxiaozhiding"></i>
                                </div>
                                <div>
                                    {{ item.text }}
                                </div>
                            </div>
                        </template>
                        <template #default>
                            <div class="line-item-details">
                                (<span :class="[{ 'line-item-number': item.passagerCount > 0 }]">
                                    {{ item.passagerCount }}
                                </span>
                                人 )
                            </div>
                        </template>
                    </van-cell>
                </div>
                <!-- 线路 -->
                <div v-if="handlerSearchLineNameList.length != 0">
                    <p class="line-title">线路</p>
                    <van-cell v-for="(item, index) in handlerSearchLineNameList" :key="index" :title="item.text" is-link
                        @click="onLineConfirm(item)" :class="['line-item', { 'label-bold': line.text === item.text }]">
                        <template #title>
                            <div class="line-item-title">
                                <div class="line-item-top" @click="onSetTop(item, $event, 'add')">
                                    <i class="iconfont iconzhiding"></i>
                                </div>
                                <div>
                                    {{ item.text }}
                                </div>
                            </div>
                        </template>
                        <template #default>
                            <div class="line-item-details">
                                (
                                <span :class="[{ 'line-item-number': item.passagerCount > 0 }]">
                                    {{ item.passagerCount }}
                                </span>
                                人 )
                            </div>
                        </template>
                    </van-cell>
                </div>
                <div v-if="handlerSearchLineNameList.length == 0 && handlerSearchSetTopList.length == 0"
                    class="line-empty">
                    暂无数据
                </div>
            </van-pull-refresh>
        </van-popup>

        <!-- 站点弹窗选择 -->
        <van-popup v-model="showNode" position="bottom" style="height: 100%;" class="linePopup">
            <van-sticky>
                <van-search v-model="searchNodeValue" placeholder="请输入站点代码或名称" show-action @cancel="showNode = false" />
            </van-sticky>
            <van-pull-refresh class="line-pull-refresh" v-model="nodeRefresh" @refresh="onGetStartNode"
                style="background-color: #f1f1f1;">
                <!-- 站点 -->
                <div v-if="handlerSearchNodeNameList.length != 0">
                    <p class="line-title">站点</p>
                    <van-cell v-for="(item, index) in handlerSearchNodeNameList" :key="item.NodeGID"
                        :title="item.NodeName" is-link @click="onNodeConfirm(item)"
                        :class="['line-item', { 'label-bold': startNode && startNode.NodeGID === item.NodeGID }]">
                        <template #title>
                            <div class="line-item-title">
                                <div>
                                    {{ item.NodeName }}
                                </div>
                            </div>
                        </template>
                        <template #default>
                            <div class="line-item-details">
                                <!-- 站点描述 -->
                            </div>
                        </template>
                    </van-cell>
                </div>
                <div v-if="handlerSearchNodeNameList.length == 0" class="line-empty">
                    暂无数据
                </div>
            </van-pull-refresh>
        </van-popup>


        <!-- 下车站点弹窗选择 -->
        <van-popup v-model="showEndNode" position="bottom" style="height: 100%;" class="linePopup">
            <van-sticky>
                <van-search v-model="searchNodeValue" placeholder="请输入站点代码或名称" show-action
                    @cancel="showEndNode = false" />
            </van-sticky>
            <van-pull-refresh class="line-pull-refresh" v-model="nodeRefresh" @refresh="onGetArrivalNode"
                style="background-color: #f1f1f1;">
                <!-- 站点 -->
                <div v-if="handlerSearchEndNodeNameList.length != 0">
                    <p class="line-title">站点</p>
                    <van-cell v-for="(item, index) in handlerSearchEndNodeNameList" :key="item.NodeGID"
                        :title="item.NodeName" is-link @click="onArrivalNodeConfirm(item)"
                        :class="['line-item', { 'label-bold': arrivalNode && arrivalNode.NodeGID === item.NodeGID }]">
                        <template #title>
                            <div class="line-item-title">
                                <div>
                                    {{ item.NodeName }}
                                </div>
                            </div>
                        </template>
                        <template #default>
                            <div class="line-item-details">
                                <!-- 站点描述 -->
                            </div>
                        </template>
                    </van-cell>
                </div>
                <div v-if="handlerSearchEndNodeNameList.length == 0" class="line-empty">
                    暂无数据
                </div>
            </van-pull-refresh>
        </van-popup>

        <!-- 查询手机尾号或证件号码 多张票信息展示 -->
        <van-popup v-model="isShowTicketList" :lock-scroll="true" position="bottom" :style="{ height: '70%' }"
            style="font-size: 20px;">
            <div style="width: 100%; height: 1rem; background-color: #f08200;">
                <van-button v-on:click="onBackListClick" type="default" style="
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 0.1rem;
            float: right;
          ">退出</van-button>
            </div>
            <div class="phoneList" v-for="item in ticketList" :key="item.OrderDetailGID">
                <div @click="onTicketClick(item)">
                    <div class="left">
                        <span class="tel" style="font-size: 24px;">
                            <a :href="'tel:' + item.CustTel">{{ item.CustTel }}</a>
                        </span>
                        <p>
                            {{ item.CustName }}
                        </p>
                        <p>
                            {{ item.BarCode }}
                        </p>
                    </div>
                    <div class="center">
                        <div>
                            <van-icon name="bookmark-o" />
                            {{ item.LineName }}
                        </div>
                        <span>{{ item.ClassDate }} {{ item.ClassTime }}</span>
                    </div>
                    <div class="right">
                        <span v-if="item.TicketStatusID == 2">
                            <van-tag type="danger" size="medium">未检</van-tag>
                        </span>
                        <span v-if="item.TicketStatusID == 4">
                            <van-tag size="medium">已订</van-tag>
                        </span>
                        <span v-if="item.TicketStatusID == 8 || item.TicketStatusID == 9">
                            <van-tag type="success" size="medium">已检</van-tag>
                        </span>
                    </div>
                </div>
            </div>
        </van-popup>

        <!-- 车票详情弹窗 -->
        <van-dialog v-if="ticketInfo" :lockScroll="true" v-model="showTicketInfo" @confirm="onCheck(ticketInfo)"
            confirm-button-color="#0000FF" confirm-button-text="检票" @cancel="showTicketInfo = false; ticketInfo = null;"
            show-cancel-button style="text-align: -webkit-auto;" :show-confirm-button="true">
            <div class="ticketContent-dialog">
                <div class="apply-box" id="apply">
                    <van-cell title="线路">
                        <template slot="default">
                            <span v-bind:class="{ colorRed: ticketInfo.LineGID != line.lineInfo.LineGID }">{{
            ticketInfo.LineName
        }}</span>
                        </template>
                    </van-cell>
                    <van-cell title="班次">
                        <template slot="default">
                            <span>{{ ticketInfo.ClassDate + " " + ticketInfo.ClassTime }}</span>
                        </template>
                    </van-cell>
                    <van-cell title="上车点">
                        <template slot="default">
                            <span
                                v-bind:class="{ colorRed: ticketInfo.StartNodeGID.toLowerCase() != startNode.NodeGID.toLowerCase() }">{{
            ticketInfo.StartNodeName }}</span>
                        </template>
                    </van-cell>
                    <van-cell title="下车点" :value="ticketInfo.ArrivalNodeName" />
                    <van-cell v-bind:class="{ colorRed: ticketInfo.OrderTypeID == 2 }"
                        :value-class="{ colorRed: ticketInfo.OrderTypeID == 2 }" title="订单类型"
                        :value="getOrderType(ticketInfo.OrderTypeID)" />
                    <van-cell title="座号" :value="ticketInfo.SeatNo +
            '(' +
            (ticketInfo.BarCode ? ticketInfo.BarCode : '未支付') +
            ')'
            " />
                    <van-cell title="票价" :value="'￥' +
            ticketInfo.TicketPrice +
            '(' +
            getTicketType(ticketInfo.TicketTypeID) +
            ')'
            " />
                    <van-cell v-if="ticketInfo.StationFee" title="站务费" :value="'￥' + ticketInfo.StationFee" />
                    <div class="empty"></div>
                </div>
                <van-cell title="号码" @click="getTicketTel(ticket)">
                    <template>
                        <span style="color: blue;">{{ ticketInfo.CustTel }}</span>
                        <!-- <span style="color: red;">({{ ticketInfo.CallCount }}次)</span> -->
                    </template>
                </van-cell>
                <van-cell title="姓名" :value="ticketInfo.CustName" />
                <van-cell title="证件类型" :value="ticketInfo.CustCertType" />
                <van-cell title="证件号码" :value="ticketInfo.CustCertNo" />
                <van-cell title="是否携童" :value="ticketInfo.IsChild?'是':'否'" />
                <van-cell title="备注" :value="ticketInfo.Remark" />
            </div>
        </van-dialog>
    </div>
</template>

<script>

// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import "@/views/AnalysisStats/style.less";
import SelectDate from "@/components/selectDate";
import dateCalendarStore from "@/stores/dateCalendarStore";

var outoAudio = new Audio();


export default {
    components: {
        Header,
        SelectDate
    },
    data() {
        return {
            title: "线路检票", //页面标题
            selectDate: dateCalendarStore.state.selectDate || new Date(),
            showLine: false,
            line: window.localStorage.getItem("line")
                ? JSON.parse(window.localStorage.getItem("line"))
                : null, //选择的线路
            orgLineNameList: [], // 线路源数据
            lineNameList: [], // 非置顶数据list
            lineNameSetTopList: [], // 置顶数据list
            searchLineValue: null,
            searchNodeValue: null,
            lineRefresh: false,
            nodeRefresh: false,
            tabactive: 0,
            startNodeList: [], //上车站点集合
            showNode: false,
            showEndNode: false,
            startNode: window.localStorage.getItem("LineCheckTicket_SelectStartNode")
                ? JSON.parse(window.localStorage.getItem("LineCheckTicket_SelectStartNode"))
                : null,
            findNumber: null,
            isShowTicketList: false,
            ticketList: [],
            showTicketInfo: false,
            ticketInfo: null,
            isFastPay: false,
            ticketType: 1,
            lineDepartureRecordList: [],
            lineTicketInfo: {
                SaleCount: 0,
                CheckCount: 0
            },
            checkMode: null, // 检票类型
            OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
            noCheckTicketList: [],
            noCheckTicketCount: 0,
            noCheckTicketPage: 1,
            arrivalNodeList: [],
            arrivalNode: window.localStorage.getItem("LineCheckTicket_SelectArrivalNode")
                ? JSON.parse(window.localStorage.getItem("LineCheckTicket_SelectArrivalNode"))
                : null,
        };
    },
    watch: {
        async showLine() {
            if (this.showLine) {
                await this.onGetCompLine();
                await this.getUserSetTopList();
            } else {
                this.searchLineValue = null;
            }
        },
        async showNode() {
            if (this.showNode) {
                await this.onGetStartNode();
            } else {
                this.searchNodeValue = null;
            }
        },
        async showEndNode() {
            if (this.showEndNode) {
                await this.onGetArrivalNode();
            } else {
                this.searchNodeValue = null;
            }
        },
        startNode() {
            if (this.startNode) {
                window.localStorage.setItem("LineCheckTicket_SelectStartNode", JSON.stringify(this.startNode));
            }
            this.tabactive = 0;
            if (this.line && this.startNode) {
                this.onGetLineNodeTicket()
            }
        },
        arrivalNode() {
            if (this.arrivalNode) {
                window.localStorage.setItem("LineCheckTicket_SelectArrivalNode", JSON.stringify(this.arrivalNode));
            }
            this.tabactive = 0;
            if (this.line && this.startNode) {
                this.onGetLineNodeTicket()
            }
        },
        //线路更改选择
        line() {
            if (this.line) {
                window.localStorage.setItem("line", JSON.stringify(this.line));
            }
            this.onGetStartNode();
            this.onGetArrivalNode();
        },
        selectDate() {
            if (this.tabactive == 2 && this.line && this.startNode) {
                this.onGetLineDepartureRecord();
            }
            if (this.line && this.startNode) {
                this.onGetLineNodeTicket()
            }
            if (this.tabactive == 1) {
                this.tabactive = 0;
            }
            this.noCheckTicketPage = 1
        },
        noCheckTicketPage() {
            if (this.tabactive == 1 && this.line && this.startNode) {
                this.onGetLineNodeTicketList(((this.noCheckTicketPage - 1) * 5), 5)
            }
        }
    },
    computed: {
        handlerSearchEndNodeNameList() {
            return this.arrivalNodeList.filter((item) => {
                return item.NodeName.includes(this.searchNodeValue);
            });
        },
        handlerSearchNodeNameList() {
            return this.startNodeList.filter((item) => {
                return item.NodeName.includes(this.searchNodeValue);
            });
        },
        handlerSearchSetTopList() {
            return this.lineNameSetTopList.filter((item) => {
                return item.text.includes(this.searchLineValue);
            });
        },
        handlerSearchLineNameList() {
            return this.lineNameList.filter((item) => {
                return item.text.includes(this.searchLineValue);
            });
        },
    },
    methods: {

        //未检列表刷新
        async onRepalyNoCheckTicektList() {
            if (this.noCheckTicketPage != 1) {
                this.noCheckTicketPage = 1
            } else {
                await this.onGetLineNodeTicketList(0, 5)
            }
        },

        //发车
        onSendCar() {
            this.$router.push({
                name: "LineCheckSendCar",
                params: {
                    selectDate: this.selectDate ? this.selectDate : new Date()
                }
            });
        },
        //快捷订位
        onFaseSeatBtnClick() {
            if (!window.framework && !this.$utils.getIsWxClient()) {
                this.$toast("未识别到有效扫码方式");
                return;
            }
            this.$dialog
                .confirm({
                    message: "请选择快捷订位车票类型",
                    confirmButtonText: "全票",
                    cancelButtonText: "半票",
                })
                .then(() => {
                    this.ticketType = 1
                    this.gotoFastPay(1);
                })
                .catch(() => {
                    this.ticketType = 2
                    this.gotoFastPay(2);
                });
        },
        gotoFastPay(ticketType) {
            this.isFastPay = false;
            var that = this;

            //that.onCreatFastOrder("111111asddasdas", ticketType);

            //调起摄像头扫码
            if (window.framework && window.framework.jsCameraScan) {
                that.isFastPay = true;
                window.framework.jsCameraScan();
                return
            } else {
                if (this.$utils.getIsWxClient()) {
                    wx.ready(function () {
                        wx.scanQRCode({
                            needResult: 1,
                            scanType: ["qrCode"],
                            success: function (t) {
                                var a = t.resultStr;
                                that.onCreatFastOrder(a, ticketType);
                            },
                            fail: function (e) {
                                alert(e);
                            },
                        });
                    });
                } else {
                    this.$toast("调起扫码失败，请检查设备！");
                    return;
                }
            }
        },
        //快捷订位订单创建
        async onCreatFastOrder(payCode, ticketType) {
            this.isFastPay = false;
            if (!payCode) {
                this.$toast("扫码失败！");
                return;
            }
            this.getLineClassDaySaleQuery(payCode, ticketType);
        },
        //获取班次数据
        getLineClassDaySaleQuery(payCode, ticketType) {
            let params = {
                AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"),
                StartNodeGID: this.startNode.NodeGID,
                ArrivalNodeGID: this.line.lineInfo.EndNodeGID,
                LineGID: this.line.lineInfo.LineGID,
                ClassDate: this.selectDate,
                OperGID: this.OperObj.GID,
            };
            this.$http
                .post(this.$api.getLineClassDaySaleQuery, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success && res.data.length > 0) {
                        //获取最近的班次
                        // 当前日期
                        let today = new Date();
                        let now = today.getTime();
                        let closestRecord = res.data
                            .map(item => {
                                // 创建当日的 classtime 日期对象
                                let [hours, minutes] = item.ClassTime.split(":").map(Number);
                                let classDate = new Date(today);
                                classDate.setHours(hours, minutes, 0, 0);

                                // 计算时间差
                                return { ...item, timeDifference: Math.abs(classDate - now) };
                            })
                            .sort((a, b) => a.timeDifference - b.timeDifference)[0];
                        //直接创建一个到达终到站的空信息订单
                        let PassengerJsonText = [
                            {
                                TicketType: this.ticketType,
                                CustName: "",
                                CustTel: null,
                                CustCertType: "其它",
                                CustCertNo: "",
                                IsChild: false,
                                ChildName: null,
                                ChildCertType: null,
                                ChildCertNo: null,
                                SeatNo: 0,
                                TicketPrice: null,
                            },
                        ];
                        let params = {
                            AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
                            LineClassDayGID: closestRecord.GID,
                            StartNodeGID: this.startNode.NodeGID,
                            // 需求4491：默认最后一个可售的下车点
                            ArrivalNodeGID: closestRecord.ArrivalNodeGID,
                            PassengerJsonText: JSON.stringify(PassengerJsonText),
                            ContactName: "",
                            ContactTel: null,
                            OrderTypeID: 1,
                            WeiXinOpenID: null,
                            WeiXinAppID: null,
                            OperGID: this.OperObj.GID, //操作员GID
                            OperCode: this.OperObj.UserCode, //操作员代码
                            OperName: this.OperObj.UserName, //操作员名称
                        };
                        this.toCreatOrder(payCode, params);
                    } else {
                        this.$dialog
                            .alert({
                                title: "提示",
                                message: "获取班次数据失败！" + res.msg,
                            })
                            .then(() => {

                            });
                    }
                })
                .catch((err) => {
                    this.$dialog
                        .alert({
                            title: "提示",
                            message: err,
                        })
                        .then(() => {

                        });
                });
        },
        toCreatOrder(payCode, params) {
            this.$http
                .post(this.$api.createTicketOrder, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success) {
                        // 支付订单 -- 扫码
                        this.doTicketOrderPayDo(
                            "AllinpayScanPayBSC",
                            res.data[0].OrderNo,
                            payCode
                        );
                        this.$toast("订单创建成功");
                    }
                })
                .catch((err) => { });
        },
        // 支付订单
        doTicketOrderPayDo(PayTypeCode, OrderNo, payCode) {
            let params = {
                PayTypeCode: PayTypeCode,
                OrderNo: OrderNo,
                OperGID: this.OperObj.GID, //操作员GID
                OperCode: this.OperObj.UserCode, //操作员代码
                OperName: this.OperObj.UserName, //操作员名称
            };
            this.$http
                .post(
                    this.$api.onTicketOrderPayDo,
                    this.$qs.stringify({
                        model: params,
                        authcode: payCode,
                    })
                )
                .then((res) => {
                    if (res.success) {
                        this.$toast("支付成功");

                        //直接检票
                        res.data.forEach((t) => {
                            this.onCheck(t, false);
                        });

                    } else {
                        this.$toast("支付失败");
                        this.onTicketOrderCancel(OrderNo);
                    }
                })
                .catch((err) => {
                    this.onTicketOrderCancel(OrderNo);
                });
        },
        //支付失败取消订单
        onTicketOrderCancel(OrderNo) {
            let params = {
                AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"),
                OrderNo: OrderNo,
                OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
                OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
                OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
            };
            this.$http
                .post(this.$api.onTicketCancel, this.$qs.stringify(params))
                .then((res) => { })
                .catch((err) => { });
        },
        //扫码检票
        onCallCameraScan() {
            this.isFastPay = false;
            if (!window.framework && !this.$utils.getIsWxClient()) {
                this.$toast("未识别到有效扫码方式");
                return;
            }
            if (window.framework) {
                window.framework.jsCameraScan();
                return;
            }
            var that = this;
            if (this.$utils.getIsWxClient()) {
                wx.ready(function () {
                    wx.scanQRCode({
                        needResult: 1,
                        scanType: ["qrCode"],
                        success: function (t) {
                            var a = t.resultStr;
                            that.checkMode = "手机相机扫码";
                            //检票情况
                            that.onCheckByIdNumber(a);
                        },
                        fail: function (e) {
                            alert('扫描失败!' + e.errMsg);
                        },
                    });
                });
            }
        },
        //获取车票手机号码
        getTicketTel(ticket) {
            var flag = this.$utils.isPhone(ticket.CustTel);
            if (flag) {
                // 拨打电话次数
                this.handlerCreateTicketCallHistory(ticket);

                window.location.href = "tel:" + ticket.CustTel;
                return;
            }
            this.$http
                .post(
                    this.$api.onTicketCustDetailQuery,
                    this.$qs.stringify({
                        TicketOrderDetailGID: ticket.OrderDetailGID,
                    })
                )
                .then((res) => {
                    if (res.success) {
                        window.location.href = "tel:" + res.data[0].CustTel;
                    }
                });
        },
        // 拨打电话次数
        handlerCreateTicketCallHistory(data) {
            let params = {
                TicketOrderDetailGID: data.OrderDetailGID,
                CustTel: data.CustTel,
                Remark: "",
                ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
                ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                    .UserCode,
                ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                    .UserName,
            };
            this.$http
                .post(
                    this.$api.TicketOrderDetailCallHistory,
                    this.$qs.stringify({
                        _JsonText: JSON.stringify(params),
                    })
                )
                .then((res) => {
                    console.log("resresres", res);
                });
        },
        //获取订单类型
        getOrderType(typeID) {
            if (typeID == 1) {
                return "购票";
            }
            if (typeID == 2) {
                return "订";
            }
            if (typeID == 3) {
                return "往返套票";
            }
            if (typeID == 4) {
                return "小点订单";
            }
            if (typeID == 5) {
                return "货款订单";
            }
        },
        //获取车票类型
        getTicketType(typeID) {
            if (typeID == 1) {
                return "全";
            } else if (typeID == 2) {
                return "半";
            } else if (typeID == 3) {
                return "优";
            } else if (typeID == 4) {
                return "站务";
            } else if (typeID == 5) {
                return "双程";
            } else if (typeID == 6) {
                return "回程";
            } else if (typeID == 7) {
                return "学生";
            } else if (typeID == 8) {
                return "军残";
            } else if (typeID == 9) {
                return "货款";
            }
        },
        onTicketClick(item) {
            this.showTicketInfo = true;
            this.ticketInfo = item
        },
        onBackListClick() {
            this.isShowTicketList = false;
            this.ticketList = [];
            this.findNumber = null;
        },
        onCheckByIdNumber(num) {
            var that = this;
            if (!num) {
                return;
            }
            let BarCode = null;
            let CustCertNo = null;
            let TelPhone = null;
            let checkticketList = [];
            if (
                num.length == 10 ||
                num.length == 8 || //兼容车站条码
                (num.length == 740 && num.indexOf("4016C800169") == 0) ||
                (num.length == 728 && num.indexOf("800169") == 0) ||
                (num.length == 21 && num.indexOf(",") == 10)
            ) {
                BarCode = num;
            } else if (num.length == 4) {
                TelPhone = num;
            } else {
                CustCertNo = num;
            }
            let params = {
                AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
                BarCode: BarCode, //车票条码
                CustCertNo: CustCertNo, //证件号码
                TelPhone: TelPhone, //手机号码后4位
                LineGID: this.line.lineInfo.LineGID,
                ClassDate: this.$moment(this.selectDate).format('YYYY-MM-DD'),
            };
            this.$http
                .post(this.$api.onCheckTicketInfo, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success) {
                        this.findNumber = "";
                        if (res.data.length == 0) {
                            that.playWav("err");
                            let msg = "";
                            if (BarCode) {
                                msg = "根据条码" + BarCode + ",没有找到车票信息";
                            }
                            if (CustCertNo) {
                                msg = "根据证件号码" + CustCertNo + ",没有找到车票信息";
                            }
                            if (TelPhone) {
                                msg = "根据手机尾号" + TelPhone + ",没有找到车票信息";
                            }
                            this.$toast(msg);
                            return;
                        }
                        for (let index = 0; index < res.data.length; index++) {
                            let ClassDate = this.$moment(res.data[index].ClassDate).format(
                                "YYYY-MM-DD"
                            );
                            //获取是否允许跨线路混检
                            let IsEnabledLineMixedCheck = this.$utils.getSysParams(
                                "IsEnabledLineMixedCheck"
                            );
                            //获取是否允许混检当天之前的票
                            let IsAllowCheckNotToDayTicket = this.$utils.getSysParams(
                                "IsAllowCheckNotToDayTicket"
                            );
                            if (
                                IsEnabledLineMixedCheck === "1" &&
                                IsAllowCheckNotToDayTicket === "1"
                            ) {
                                checkticketList.push(res.data[index]);
                            }
                            if (
                                IsEnabledLineMixedCheck === "1" &&
                                IsAllowCheckNotToDayTicket === "0"
                            ) {
                                if (this.$moment(ClassDate).diff(this.$moment(), "days") >= 0) {
                                    checkticketList.push(res.data[index]);
                                }
                            }
                            if (
                                IsEnabledLineMixedCheck === "0" &&
                                IsAllowCheckNotToDayTicket === "0"
                            ) {
                                if (
                                    res.data[index].LineGID == this.line.lineGID &&
                                    this.$moment(ClassDate).diff(this.$moment(), "days") >= 0
                                ) {
                                    checkticketList.push(res.data[index]);
                                }
                            }
                            if (
                                IsEnabledLineMixedCheck === "0" &&
                                IsAllowCheckNotToDayTicket === "1"
                            ) {
                                if (res.data[index].LineGID == this.line.lineGID) {
                                    checkticketList.push(res.data[index]);
                                }
                            }
                        }
                        if (checkticketList.length == 0) {
                            that.playWav("err");
                            //没有对应规则的票
                            this.$toast.fail("没有找到车票记录!");
                        } else if (checkticketList.length == 1) {
                            if (TelPhone) {
                                this.showTicketInfo = true;
                                this.ticketInfo = checkticketList[0]
                                return
                            }
                            this.onCheck(checkticketList[0])
                        } else {
                            this.ticketList = checkticketList;
                            this.isShowTicketList = true
                        }
                    } else {
                        that.playWav("err");
                    }
                });
        },
        // 获取检票方式
        getCheckFlag(type) {
            let checkMode = 1;
            switch (type) {
                case "nfc刷卡":
                    checkMode = 5;
                    break;
                case "手持机扫码":
                    checkMode = 4;
                    break;
                case "手持机刷卡":
                    checkMode = 3;
                    break;
                case "手机相机扫码":
                    checkMode = 6;
                    break;
            }
            return checkMode;
        },
        //检票
        onCheck(ticket) {
            let checkModeFlag = this.getCheckFlag(this.checkMode);

            let params = {
                AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
                BarCode: ticket.BarCode, //车票条码
                LineClassDayGID: ticket.LineClassDayGID, //日班次GID
                StartNodeGID: this.startNode.NodeGID, //发车点GID
                CheckModeFlag: checkModeFlag, //检票模式
                OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
                OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
                OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
            };
            this.$http
                .post(this.$api.onCheckTicket, this.$qs.stringify(params))
                .then((res) => {
                    this.checkMode = null;
                    if (res.success) {
                        //判断是否存在返回信息
                        if (res.data.TicketCheckBackMsg) {
                            alert(res.data.TicketCheckBackMsg);
                        }
                        if (this.isShowTicketList) {
                            this.isShowTicketList = false
                            this.ticketList = null
                            this.ticketInfo = null
                        }
                        this.playWav("check");
                        this.$toast.success("检票成功");
                        if (checkModeFlag == 4 || checkModeFlag == 6) {
                            var that = this;
                            setTimeout(function () {
                                that.onCallCameraScan();
                            }, 1000);
                        }

                    } else {
                        //关闭检票弹窗
                        this.playWav("err");
                        //this.$toast.fail("检票失败");
                        this.$dialog.alert({
                            title: "温馨提示",
                            message: "检票失败，请点击确认后重试",
                        });
                    }
                })
                .catch((err) => {
                    this.playWav("err");
                    //this.$toast.fail("检票失败：" + err);
                    this.$dialog.alert({
                            title: "温馨提示",
                            message: "检票失败，请点击确认后重试" + err,
                        });
                });
        },
        //站点选择
        onNodeConfirm(value) {
            this.showNode = false;
            this.startNode = value;
        },
        onArrivalNodeConfirm(value) {
            this.showEndNode = false;
            this.arrivalNode = value;
        },
        //音效播放
        playWav(type) {
            switch (type) {
                case "nfc":
                    outoAudio.src = require("@/img/ding.mp3");
                    outoAudio.play();
                    break;
                case "check":
                    outoAudio.src = require("@/img/checksuccess.mp3");
                    outoAudio.play();
                    break;
                case "err":
                    outoAudio.src = require("@/img/checkfail.mp3");
                    outoAudio.play();
                    break;
            }
            // }
        },
        //点击选项卡
        async tabsClick(name, title) {
            if (this.line && this.startNode && title == "发车记录") {
                await this.onGetLineDepartureRecord()
            }

            if (this.line && this.startNode && title == "未检列表") {
                this.noCheckTicketList = []
                this.noCheckTicketCount = 0
                await this.onRepalyNoCheckTicektList()
            }
        },
        // 设置置顶
        onSetTop(data, e, type) {
            e.stopPropagation();
            let list = this.$utils.getAdminUserConfig("LineFavorites");
            let adminInfo = JSON.parse(localStorage.getItem("adminInfo"));

            if (type == "add") {
                if (list.length != 0) {
                    list.forEach((item) => {
                        item.OrderByNo += 1;
                    });
                }
                list.unshift({
                    LineGID: data.lineGID,
                    OrderByNo: 0,
                });
            } else if (type == "delete") {
                list = list.filter((item) => {
                    return item.LineGID != data.lineGID;
                });
            }
            let params = {
                UserGID: adminInfo.GID,
                ConfigKey: "LineFavorites",
                ConfigValue: JSON.stringify(list),
            };
            this.$http
                .post(this.$api.SysUserSysUserConfigSave, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success) {
                        setTimeout(async () => {
                            await this.getUserInfo();
                            await this.getUserSetTopList();
                        }, 500);
                    }
                });
        },

        // 获取置顶数据
        getUserSetTopList() {
            let temp = [];
            this.lineNameSetTopList = [];
            let list = this.$utils.getAdminUserConfig("LineFavorites");
            list.forEach((item) => {
                this.orgLineNameList.forEach((i) => {
                    if (item.LineGID == i.lineGID) {
                        temp.push(i);
                    }
                });
            });
            this.lineNameSetTopList = temp;
            // 筛选非置顶数据
            let arr = temp.map((item) => item.lineGID);
            this.lineNameList = this.orgLineNameList.filter(
                (item) => !arr.includes(item.lineGID)
            );
        },
        // 获取用户数据
        getUserInfo() {
            return new Promise((resolve, reject) => {
                let params = {
                    _Authorization: window.localStorage.getItem("_cyw_token"),
                };
                this.$http
                    .post(this.$api.getUserInfo, this.$qs.stringify(params))
                    .then((res) => {
                        if (res.success) {
                            window.localStorage.setItem(
                                "adminUserConfig",
                                JSON.stringify(res.data.SysUserConfig)
                            );
                            resolve(true);
                        }
                    });
            });
        },

        //线路选中
        onLineConfirm(value) {
            this.showLine = false;
            this.line = value;
        },
        //获取线路下车点信息
        onGetArrivalNode() {
            if (!this.line) {
                return;
            }
            return new Promise((resolve, reject) => {
                this.arrivalNodeList = [];
                this.arrivalNode = null;
                let params = {
                    LineGID: this.line.lineInfo.LineGID,
                };

                this.$http
                    .post(this.$api.getLineClassArrivalNode, this.$qs.stringify(params))
                    .then((res) => {
                        if (res.success) {
                            res.data.forEach((item) => {
                                //if (item.HandheldManageIsShowThisNode == 1) {
                                this.arrivalNodeList.push(item);
                                //}
                            });
                            resolve(true);
                            if (this.nodeRefresh) {
                                this.nodeRefresh = false;
                            }
                        }
                    });
            });
        },
        //获取线路上车点信息
        onGetStartNode() {
            if (!this.line) {
                return;
            }
            return new Promise((resolve, reject) => {
                this.startNodeList = [];
                let params = {
                    LineGID: this.line.lineInfo.LineGID,
                };

                this.$http
                    .post(this.$api.getLineClassStartNode, this.$qs.stringify(params))
                    .then((res) => {
                        if (res.success) {
                            res.data.forEach((item) => {
                                //if (item.HandheldManageIsShowThisNode == 1) {
                                this.startNodeList.push(item);
                                //}
                            });
                            resolve(true);
                            if (res.data.length > 0) {
                                if (this.startNode) {
                                    let info = null;
                                    this.startNodeList.forEach((nodec) => {
                                        if (nodec.NodeGID == this.startNode.NodeGID) {
                                            info = nodec;
                                        }
                                    });
                                    info
                                        ? (this.startNode = info)
                                        : (this.startNode = this.startNodeList[0]);
                                } else {
                                    this.startNode = this.startNodeList[0];
                                    return;
                                }
                            } else {
                                this.startNode = null;
                            }
                            if (this.nodeRefresh) {
                                this.nodeRefresh = false;
                            }
                        }
                    });
            });
        },
        //获取公司线路
        onGetCompLine() {
            return new Promise((resolve, reject) => {
                this.orgLineNameList = [];
                let params = {
                    OrganizationGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                        .OrganizationGID,
                    QueryDate: this.$moment(this.selectDate).format("YYYY-MM-DD"),
                };
                this.$http
                    .post(this.$api.getGetCompLine, this.$qs.stringify(params))
                    .then((res) => {
                        if (res.success) {
                            res.data.forEach((item, i) => {
                                if (item.LineIsEnabled && item.IsEnabled) {
                                    this.orgLineNameList.push({
                                        text: item.LineName,
                                        keyID: item.LineGID,
                                        index: i,
                                        lineInfo: item,
                                        lineGID: item.LineGID,
                                        lineCode: item.LineCode,
                                        lineClassDayCount: item.LineClassDayCount,
                                        passagerCount: item.PassagerCount,
                                    });
                                }
                            });
                            resolve(true);
                            if (res.data.length > 0) {
                                if (this.line) {
                                    let info = null;
                                    this.orgLineNameList.forEach((linec) => {
                                        if (linec.lineInfo.GID == this.line.lineInfo.GID) {
                                            info = linec;
                                        }
                                    });
                                    info
                                        ? (this.line = info)
                                        : (this.line = this.orgLineNameList[0]);
                                } else {
                                    this.line = this.orgLineNameList[0];
                                    // this.lineDefaultIndex = 0;
                                    return;
                                }
                            } else {
                                this.line = null;
                            }
                            if (this.lineRefresh) {
                                this.lineRefresh = false;
                            }
                        }
                    });
            });
        },
        //获取线路发车记录
        onGetLineDepartureRecord() {
            return new Promise((resolve, reject) => {
                this.lineDepartureRecordList = [];
                let params = {
                    LineGID: this.line.lineInfo.LineGID,
                    BeginDate: this.$moment(this.selectDate).format('YYYY-MM-DD'),
                    EndDate: this.$moment(this.selectDate).format('YYYY-MM-DD'),
                    NodeGID: this.startNode.NodeGID,
                    dir: 'DESC'
                };
                this.$http
                    .post(this.$api.getLineDepartureRecord, this.$qs.stringify(params))
                    .then((res) => {
                        resolve(true);
                        if (res.success) {
                            this.lineDepartureRecordList = res.data
                        }
                    });
            });
        },
        //获取线路车票信息
        onGetLineNodeTicket() {
            if (!this.line || !this.startNode) {
                return;
            }
            return new Promise((resolve, reject) => {
                let params = {
                    LineGID: this.line.lineInfo.LineGID,
                    NodeGID: this.startNode.NodeGID,
                    ArrivalNodeGID: this.arrivalNode ? this.arrivalNode.NodeGID : null,
                    ClassDate: this.$moment(this.selectDate).format('YYYY-MM-DD'),
                    Type: 0
                };
                this.$http
                    .post(this.$api.getLineNodeTicket, this.$qs.stringify(params))
                    .then((res) => {
                        if (res.success) {
                            this.lineTicketInfo = res.data[0]
                            resolve(true);
                        }
                    });
            });
        },
        //获取线路车票列表信息
        onGetLineNodeTicketList(start, limit) {
            if (!this.line || !this.startNode) {
                return;
            }
            return new Promise((resolve, reject) => {
                let params = {
                    LineGID: this.line.lineInfo.LineGID,
                    NodeGID: this.startNode.NodeGID,
                    ArrivalNodeGID: this.arrivalNode ? this.arrivalNode.NodeGID : null,
                    ClassDate: this.$moment(this.selectDate).format('YYYY-MM-DD'),
                    Type: 1,
                    start: start,
                    limit: limit
                };
                this.$http
                    .post(this.$api.getLineNodeTicket, this.$qs.stringify(params))
                    .then((res) => {
                        if (res.success) {
                            this.noCheckTicketList = res.data
                            this.noCheckTicketCount = res.total
                            resolve(true);
                        }
                    });
            });
        },
    },
    mounted: async function () {
        await this.onGetCompLine();

        if (window.framework) {
            // 打开扫描
            if (window.framework.isReadScanner) {
                window.framework.isReadScanner(true);
            }
            //开启NFC模块
            if (window.framework.isReadCard) {
                window.framework.isReadCard(true);
            }
            //手持机设备刷身份证
            var fun = function (jsonObj) {
                if (!jsonObj.type) {
                    this.checkMode = "手持机刷卡";
                } else {
                    this.checkMode = jsonObj.type;
                }
                //读取失败
                if (!jsonObj.success) {
                    this.$toast.fail("身份证读取失败！");
                    return;
                }
                this.onCheckByIdNumber(jsonObj.data["身份号码"]);
            };

            //手机nfc刷身份证
            var nfcFun = function (ReqId, AndroidID) {
                //打印AndroidID
                console.log("AndroidID:" + AndroidID);
                this.checkMode = "nfc刷卡";
                //读取失败
                if (!ReqId) {
                    this.playWav("err");
                    this.$toast.fail("身份证读取失败！");
                    return;
                }
                this.playWav("nfc");
                //调动后端接口获取身份信息
                this.$http
                    .post(
                        this.$api.getIdCardCloudDecode,
                        this.$qs.stringify({ ReqId: ReqId, AndroidID: AndroidID })
                    )
                    .then((res) => {
                        if (res.success) {
                            //alert(JSON.stringify(res.data))
                            //将身份信息转为CardInfo对象  暂时只有两项信息 号码及姓名；返回图片会导致服务器加解密时间过长。
                            let jsonObj = {
                                success: res.success,
                                data: {
                                    姓名: res.data.Name,
                                    身份号码: res.data.IdNum,
                                    照片: res.data.Picture,
                                    性别: res.data.Sex,
                                    民族: res.data.Nation,
                                    出生日期: res.data.BirthDate
                                        ? this.$moment(res.data.BirthDate).format("YYYY-MM-DD")
                                        : null, //格式化
                                    地址: res.data.Address,
                                },
                                type: "nfc刷卡",
                            };
                            fun.bind(this)(jsonObj);
                        }
                    });
            };

            //NFC读取身份证
            window.callJSIdCardCloudDecode = nfcFun.bind(this);
            //读取身份证回调
            window.callJSPersonInfo = fun.bind(this);

            //扫码枪回调
            var JsscanBack = function (code) {

                //扫码失败
                if (code == "" || code == null || code.length == 0) {
                    this.$toast.fail("扫码失败！");
                    return;
                }
                //检票情况
                if (this.isFastPay) {
                    //快捷订位
                    this.onCreatFastOrder(code);
                } else {
                    this.checkMode = "手持机扫码";
                    //检票情况
                    this.onCheckByIdNumber(code);
                }
            };
            window.callJSScan = JsscanBack.bind(this);

            //手机扫码回调
            var phoneScanfun = function (scanResult) {

                //扫码失败
                if (scanResult == "" || scanResult == null || scanResult.length == 0) {
                    this.$toast.fail("扫码失败！");
                    return;
                }
                if (this.isFastPay) {
                    //快捷订位
                    this.onCreatFastOrder(scanResult);
                } else {
                    this.checkMode = "手机相机扫码";
                    //检票情况
                    this.onCheckByIdNumber(scanResult);
                }

            };
            // 扫码
            window.callCameraScan = phoneScanfun.bind(this);
        }


    },
    created() {
        var ua = navigator.userAgent.toLowerCase();
        //判断是否微信内置浏览器环境
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //"https://wx.open.class.busboss.cn/Weixin/JSAPI"  "https://wxcs.busboss.cn/Weixin/JSAPI"
            this.$http
                .post(
                    "https://wx.open.class.busboss.cn/Weixin/JSAPI",
                    // "https://wxcs.busboss.cn/Weixin/JSAPI",
                    this.$qs.stringify({
                        url: encodeURIComponent(window.location.href.split("#")[0]),
                        AppID: "wx5e2cde762ffa2228",
                    })
                )
                .then(function (e) {
                    var t = e;
                    console.log(t, e);
                    if (t) {
                        // eslint-disable-next-line no-undef
                        wx.config({
                            debug: !1,
                            appId: t.appId,
                            timestamp: parseInt(t.timestamp),
                            nonceStr: t.noncestr,
                            signature: t.signature,
                            jsApiList: ["scanQRCode"],
                        });
                    }
                });
        }

    },

    // 首页进入初始化仓库
    beforeRouteEnter(to, from, next) {
        if (from.path == "/") {
            dateCalendarStore.commit("initializeState", {
                selectDateIndex: 0,
                caldendarDefaultDate: new Date(),
                selectDate: new Date(),
                dateList: [],
            });
        }
        next();
    },
    destroyed() {
        if (window.framework) {
            if (window.framework.isReadCard) {
                window.framework.isReadCard(false);
            }

            if (window.framework.isReadScanner) {
                //关闭扫描头
                window.framework.isReadScanner(false);
            }
            window.callJSScan = null;
        }

    },
};
</script>

<style scoped lang="less">
.nodeManage {
    padding: 0 10px;

    .timeItem {
        .classTimeWrapClass {
            padding: 0.2rem 0;
            box-sizing: border-box;

            &:last-child:nth-child(3n-1) {
                margin-right: calc(30% + 10% / 3);
            }

            &:last-child:nth-child(3n-2) {
                margin-right: calc(60% + 20% / 3);
            }

            .classTimeClass {
                border-radius: 5px;
                background-color: #f7f6f6;
                padding: 0.2rem;
                height: 100%;
                box-sizing: border-box;
                box-shadow: 1px 3px 5px 2px #d8d8d8;

                .classTime {
                    flex: 1;
                    font-size: 0.55rem;
                }

                .vehicleListClass {
                    flex: 1;
                }

                .classInfoClass {
                    flex-direction: column;
                    font-size: 0.35rem;
                }
            }

            .classTimeActive {
                border: 1px solid #f5ab4a;
            }

            // 停班
            .stopClass {
                padding: 0.03rem 0.05rem;
                background: red;
                border-radius: 5px;
                color: white;
                font-size: 0.35rem;
            }

            .openClass {
                padding: 0.03rem 0.05rem;
                background: #70b603;
                border-radius: 5px;
                color: white;
                font-size: 0.35rem;
            }

            // 售票
            .sellTickets {
                color: #5f5f5f;
                margin-right: 20px;

                &>span {
                    font-weight: bold;
                    color: #0d0dfe;
                }
            }

            .checkTickets {
                color: #5f5f5f;

                &>span {
                    font-weight: bold;
                    color: #f5a43a;
                }
            }
        }
    }

    .nodeCarList {

        // 站点
        .tabNode {
            .tabNodeItem {
                border: 0.0625rem solid;
                border-radius: 0.15625rem;
                overflow: hidden;

                .van-cell-group .van-cell::after {
                    border-bottom: 1px solid #ccc;
                }

                .van-cell-group .van-cell {
                    font-size: 0.5rem;
                }

                .timeNede {
                    display: flex;
                    align-items: center;

                    .classTime {
                        font-size: 0.56rem;
                        font-weight: 700;
                    }

                    .nodeName {
                        font-size: 0.44rem;
                    }
                }

                .textRed {
                    color: red;
                }

                .sendCarBtn {
                    color: white;
                    border: 0;
                    font-size: 0.5rem;
                    border-radius: 0;
                }
            }
        }

        // 车辆
        .tabCar {
            .vehicleBox {
                border: 0.03125rem solid;
                padding: 0.3125rem 0.3125rem 0 0.3125rem;
            }

            .vehicleBox div {
                display: flex;
                justify-content: space-between;
                line-height: 0.8rem;
            }

            .vehicleBox .van-icon {
                line-height: 0.8rem;
                color: #ccc;
            }

            .vehicleBox .van-panel__footer {
                display: flex;
                justify-content: space-between;
            }

            .vehicleBox .footer {
                overflow: hidden;
                width: 100%;
            }

            .vehicleBox .footer .van-row {
                width: 100%;
            }
        }
    }

    .cellIconClass {
        margin-right: 0.2rem;
    }

    .cellTitleClass {
        font-size: 0.45rem;
        color: #323233;
        font-weight: bolder;
        text-align: left;
    }

    .cellValueClass {
        font-size: 16px;
        color: #323233;
    }
}

// 线路弹出层
.linePopup {
    display: flex;
    flex-direction: column;

    .van-cell::after {
        border-bottom: 1px solid #ccc;
    }

    .label-bold {
        .van-cell__title {
            font-weight: bold;
        }
    }

    .line-pull-refresh {
        flex: 1;
        overflow-y: auto;

        .line-title {
            text-align: left;
            font-size: 0.32rem;
            color: #969799;
            padding: 2px 10px;
        }

        .line-item {
            .line-item-title {
                display: flex;

                .line-item-top {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 0.2rem;
                    padding: 0 0.1rem;

                    .iconfont {
                        color: #5f5f5f;
                        font-size: 0.5rem;
                    }
                }

                .line-item-top:active {
                    background-color: #9e9e9ea2;
                    border-radius: 5px;
                }
            }

            .line-item-details {
                margin-right: 0.2rem;

                .line-item-number {
                    color: orange;
                    font-weight: 700;
                    font-size: 0.42rem;
                }
            }

            .van-cell__title {
                text-align: left;
            }
        }

    }
}

.line-empty {
    padding: 10px 0;
}

.phoneList {
    width: 100%;
    height: auto;
    border-bottom: 1px solid #ccc;
    padding: 0.2rem;
    box-sizing: border-box;
}

.phoneList>div {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}

.phoneList>div>.left {
    flex: 1;
}

.phoneList>div>.center {
    flex: 1.2;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 8rem;
}

.phoneList>div>.right {
    flex: 0.6;
    width: 6rem;
}

.ticketContent-dialog {
    max-height: 400px;
    overflow: auto;
}

.apply-box>.empty {
    margin: 0 16px;
    border-bottom: 1px solid #ebedf0;
    transform: scaleY(0.1);
}

.van-cell {
    color: #969799;
    line-height: 0.5rem;
}

.van-cell__value {
    color: #000000;
    overflow: visible;
    text-align: right;
    position: relative;
    vertical-align: middle;
}

.van-cell-info {
    font-size: 12px;
    text-align: left;
}

.colorRed {
    color: red;
}

.lineCheck_checkStats_container {
    display: flex;
    flex-direction: column;
    font-size: 0.385rem;
    margin-top: 0.256rem;
    margin-bottom: 0.256rem;
    background-color: #fff;

    .stats_container {
        .stats_panel {
            margin-bottom: 0.256rem;

        }

        .stats_item_list {
            margin-top: 0;
        }
    }
}

.order_panel {
    border-radius: 10px;
    padding: 0.15rem;
    background-color: #fff;
    text-align: left;
    position: relative;
}
</style>